import {FlashResultsQuestionsList} from "../../../lists/courses/flash/FlashResultsQuestionsList";
import SystemResultsCardHeaderDivider from "../../../dividers/SystemResultsCardHeaderDivider";
import FlashResultsCardHeader from "../../../others/courses/flash/FlashResultsCardHeader";

export default function FlashResultsDesktopQuestionsCard({questions}) {
    // Used in FlashResultsScreen to display Questions List Card
    // in desktop mode

    // BUILD
    return (
        <div className={"overflow-auto bg-backgroundLight5 hidden h-[544px] min-h-[544px] max-h-[544px] w-[536px] max-w-[536px] lg:flex lg:flex-col shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px]"}>
            {/** CORE */}
            <FlashResultsCardHeader headerTitle={`Liste des questions (${questions?.length})`} />
            <SystemResultsCardHeaderDivider />
            <div className={"overflow-auto bg-backgroundLight5 w-full grow shadow-[inset_0px_0px_2px_rgba(82,96,120,1)]"}>
                <FlashResultsQuestionsList questions={questions} />
            </div>
        </div>
    );
}